export default class Video {
  constructor() {
    this.video = document.querySelector('.js--video');
    this.videoButton = document.querySelector('.js--video-button');
    this.videoButtonIcon = document.querySelector('.js--video-button__img');
    if (this.video !== null) {
      this._setDOMReferences();
    }
  }

  _setDOMReferences() {
    this.videoButton.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play();
        this.videoButton.classList.add('js--video-button--is-playing');
        this.videoButtonIcon.src = '/public/gfx/pause.svg';
      } else {
        this.video.pause();
        this.videoButton.classList.remove('js--video-button--is-playing');
        this.videoButtonIcon.src = '/public/gfx/play.svg';
      }
    });
  }
}
